import styled from "styled-components";
import AppWrapper from "../../layout/AppWrapper";
import Title from "../../utils/Title";
import AllCustomers from "../../components/user/customers/AllCustomers";


function Customers() {

  return (
    <>
      <AppWrapper
        pagename={"customers"}
      >
        <StyledCustomers>
          <Title title={"Customers"} btnName={""} />
        </StyledCustomers>

        <AllCustomers />


      </AppWrapper>

    </>
  );
}

export default Customers;

const StyledCustomers = styled.div`
  

`;